export default {
  Title: 'Fiscal Documents | Fiscal Document | Fiscal Documents',

  Status: {
    Transmitted: {
      Id   : 1,
      Name : 'Transmitted',
      Color: 'blue lighten-1'
    },
    Canceled: {
      Id   : 2,
      Name : 'Cancelled',
      Color: 'red'
    },
    Issued: {
      Id   : 3,
      Name : 'Issued',
      Color: 'blue lighten-1'
    },
    Closed: {
      Id   : 4,
      Name : 'Closed',
      Color: 'success'
    },
    Open: {
      Id   : 5,
      Name : 'Open',
      Color: 'warning'
    },
    Waiting: {
      Id   : 6,
      Name : 'Waiting',
      Color: 'blue-grey'
    },
    Error: {
      Id   : -1,
      Name : 'Error',
      Color: 'error'
    }
  },

  Table: {
    Toolbar: {
      Button: {
        Transactions: {
          Title: 'EFT/POS Transactions',
          Icon : 'mdi-account-credit-card',
          Color: 'primary'
        },
        Export: {
          Title  : 'Export',
          Icon   : 'file_download',
          Color  : 'primary',
          Success: 'Soon you\'ll receive a file with the exported fiscal documents at the email(s) you selected'
        }
      },

      Info: {
        CompanyPackage: {
          Provider      : 'Provider',
          PackageName   : 'Package',
          InitialValue  : 'Value',
          RemainingValue: 'Remaining Value',
          ValidFrom     : 'Activation',
          ValidTo       : 'Expiration'
        }
      }
    },

    Button: {
      View: {
        Title: 'View Customer',
        Icon : 'remove_red_eye',
        Color: 'cyan'
      },
      Delete: {
        Title: 'Delete Customer',
        Icon : 'delete',
        Color: 'red'
      }
    },

    Headers: {
      Id      : '#',
      Type    : 'Type',
      Table   : 'Τραπέζι',
      Number  : 'Total Num.',
      Order   : 'Order',
      Total   : 'Total',
      Aade    : 'AADE',
      Status  : 'Status',
      ClosedBy: 'Closed By',
      Related : 'Related Docs',
      User    : 'User',
      Notify  : 'Notify',
      Date    : 'Date',
      Actions : ''
    },

    Filter: {
      filterFailure: {
        Type       : 'v-btn-toggle',
        Label      : 'Connection Loss',
        PlaceHolder: 'All Documents',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: null,
            Name : 'All',
            Icon : 'mdi-wifi',
            Color: 'blue darken-1',
            Class: 'white--text'
          },
          {
            Value: 'true',
            Name : 'With Loss',
            Icon : 'mdi-wifi-remove',
            Color: 'red darken-1',
            Class: 'white--text'
          },
          {
            Value: 'false',
            Name : 'Without Loss',
            Icon : 'mdi-wifi-check',
            Color: 'light-green darken-1',
            Class: 'white--text'
          }
        ]
      },
      filterWithoutOpenHours: {
        Type       : 'v-btn-toggle',
        Label      : 'Based on',
        PlaceHolder: 'All Documents',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 'true',
            Name : 'Open Hours',
            Icon : 'mdi-wifi-remove',
            Color: 'red darken-1',
            Class: 'white--text'
          },
          {
            Value: 'false',
            Name : 'Calendar',
            Icon : 'mdi-wifi-check',
            Color: 'light-green darken-1',
            Class: 'white--text'
          }
        ]
      },
      filterStatus: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Document Status',
        PlaceHolder: 'All Documents',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        Items      : []
      },
      filterInvoiceType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Document Type',
        PlaceHolder: 'All types',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        Items      : []
      },
      filterUser: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'User',
        PlaceHolder: 'All users',
        ItemText   : 'FullName',
        ItemValue  : 'Id',
        Items      : []
      },
      filterCompany: {
        Type       : 'v-autocomplete',
        Chips      : true,
        Multiple   : false,
        Label      : 'Customers/Companies',
        PlaceHolder: 'All Customers/Companies',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        Items      : []
      }
    }
  },

  DocumentsStatus: {
    Warning: 'There are open order documents (8.6) for more than {minhours} hour, and they should be closed the latest within 24 hours from their creation.<br><br>The system will automatically cancel them after {maxhours} hours to prevent provider locking your account. | There are open order documents (8.6) for more than {minhours} hours, and they should be closed the latest within 24 hours from their creation.<br><br>The system will automatically cancel them after {maxhours} hours to prevent provider locking your account.'
  }
}
